import { AxiosResponse } from 'axios';
import { axiosBaseInstance } from './config';
import type { BusinessConfig } from '../config/businesses';

const fetchBusinesses = async (): Promise<BusinessConfig[]> => {
  const response: AxiosResponse<BusinessConfig[]> = await axiosBaseInstance({
    headers: { 'Content-Type': 'application/json' },
    method: 'get',
    url: '/api/businesses/list',
  });

  const data = response?.data ?? [];

  return data.map(business =>
    business.id === 1
      ? {
          ...business,
          departments: business.departments.filter(d => d.name === 'Demo'),
        }
      : business
  );
};

const businessesService = {
  fetchBusinesses,
};

export default businessesService;
